import { RouterModule, Routes } from '@angular/router'

// Import components
import { BusAttendanceComponent } from './BusAttendanceComponent'

const BusAttendaceRoutes : Routes = [
    {path: 'bus-attendance', component: BusAttendanceComponent},
    {path: 'bus-attendance/:id', component: BusAttendanceComponent}
];

export const BusAttendanceRouter = RouterModule.forChild(BusAttendaceRoutes);


// WEBPACK FOOTER //
// ./src/bus/parent/bus-attendance/BusAttendanceRouting.ts